import axios from "axios";
const BASE_HATTRICK_URL = import.meta.env.VITE_HATTRICK_URL;
const BALLPARK_BACKEND_BASE_URL = import.meta.env.VITE_BALLPARK_API_URL;

export async function updateProductMetadata(user, axiosOptions, productMetadataId, sizeRange, style, colorReference) {
    console.log("updateProductMetadata called");
  
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.stsTokenManager.accessToken,
    };
  
    const payload = {
      product_metadata_id: productMetadataId,
      size_range: sizeRange,
      type: style,
      color_reference: colorReference,
    };
  
    try {
      const response = await axios.post(
        `${BASE_HATTRICK_URL}products/updateProductMetadata`, // Ensure correct backend endpoint
        payload,
        { ...axiosOptions, headers }
      );
      return response.data; // Return only the response data
    } catch (error) {
      console.error("Failed to update product metadata:", error);
      throw error; // Rethrow for handling at the call site
    }
  }

